// src/socket.js
import { io } from 'socket.io-client';
import { getAuth } from 'firebase/auth';

/**
 * The live notification connection. It signs in with the seller's Firebase ID token, the same one every API
 * call sends, and the server sends it only that seller's notifications. NotificationProvider connects it once
 * a seller is signed in; every (re)connection asks Firebase for a current token.
 */
const socket = io(process.env.REACT_APP_HOST_API || 'http://localhost:4000', {
  transports: ['websocket', 'polling'], // include polling as a fallback
  secure: true,
  autoConnect: false,
  auth: (send) => {
    const seller = getAuth().currentUser;
    if (!seller) {
      send({});
      return;
    }
    seller.getIdToken().then((token) => send({ token }), () => send({}));
  },
});

export default socket;
